import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import { useDispatch } from 'react-redux';
import React from 'react';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import ConsentModalCustomization from '../customizations/ConsentModalCustomization';

const ConsentModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.CONSENT_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('personal-consent-page.consents')}>
			<ModalClose onClose={handleOnCloseModal} />
			<ConsentModalCustomization />
		</Modal>
	);
};

export default ConsentModal;
